export const removeCSRFToken = () => {
  window.document.cookie = 'csrftoken=; path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT';
};
